import React, { useState, useEffect } from 'react';
import { getGoal, addGoal } from "../../utils/api"; // Ensure these are correctly implemented
import Modal from 'react-modal'; // Install with `npm install react-modal`
import '../../App.css'; // Custom styles

Modal.setAppElement('#root'); // For accessibility compliance

const CaloricGoal = ({ userId, onUpdateGoal }) => {
    {/* onUpdateGoal */ }
    const [goal, setGoal] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [caloricGoal, setCaloricGoal] = useState({
        calories: '',
        proteins: '',
        carbs: '',
        fats: '',
    });

    useEffect(() => {
        const fetchGoal = async () => {
            try {
                const userGoal = await getGoal(userId);
                if (userGoal && userGoal.length > 0) {
                    setGoal(userGoal[0]); // Assuming `getGoal` returns an array
                } else {
                    setIsModalOpen(true); // No goal found
                }
            } catch (error) {
                console.error('Error fetching goal:', error);
            }
        };
        fetchGoal();
    }, [userId]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setCaloricGoal({ ...caloricGoal, [name]: value });
    };

    const handleSaveGoal = async (e) => {
        e.preventDefault();
        // Input validation
        const { calories, proteins, carbs, fats } = caloricGoal;
        if (!calories || !proteins || !carbs || !fats) {
            alert('יש למלא את כל השדות');
            return;
        }
        try {
            await addGoal(userId, caloricGoal);
            setGoal(caloricGoal);
            setIsModalOpen(false); // Close modal
            onUpdateGoal(caloricGoal); // Call the callback to update the goal in FoodTrack

        } catch (error) {
            console.error('Error saving goal:', error);
            alert('שגיאה בשמירת היעד. נסה שוב מאוחר יותר.');
        }
    };

    return (
        <div className="caloric-goal-container">
            {goal ? (
                <div style={{
                    maxWidth: '100%',
                    margin: '20px auto',
                    padding: '20px',
                    borderRadius: '10px',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                    backgroundColor: '#fff',
                    textAlign: 'right',
                    fontFamily: 'GveretLevin',
                    lineHeight: '1.6',
                }}>

                    <h3 style={{
                        fontSize: '1em',
                        color: '#333',
                        borderBottom: '2px solid #C4A484',
                        paddingBottom: '10px',
                        marginBottom: '15px',
                        textAlign: 'center',
                    }}>היעד הקלורי שלך

                        <span
                            onClick={() => setIsModalOpen(true)}
                            style={{
                                fontSize: '0.9em',
                                color: '#007bff',
                                cursor: 'pointer',
                                textDecoration: 'underline',
                                alignSelf: 'flex-start',
                                justifyContent: 'left',
                                marginRight: '10px'
                            }}
                        >
                            עריכה
                        </span>
                    </h3>
                    <p><strong>קלוריות:</strong> {goal.calories}</p>
                    <p><strong>חלבונים:</strong> {goal.proteins}</p>
                    <p><strong>פחמימות:</strong> {goal.carbs}</p>
                    <p><strong>שומנים:</strong> {goal.fats}</p>
                </div>
            ) : (
                <p style={{
                    textAlign: 'center',
                    fontSize: '1em',
                    color: '#666',
                    fontFamily: 'GveretLevin',
                }}>אין יעד מוגדר.</p>
            )}


            <Modal
                isOpen={isModalOpen}
                onRequestClose={() => setIsModalOpen(false)}
                className="modal"
                overlayClassName="modal-overlay"
            >
                <h2 className="modal-title">הזן את יעד הקלורי</h2>
                <form className="modal-form" onSubmit={handleSaveGoal}>
                    <div className="form-group">
                        <label>קלוריות</label>
                        <input
                            type="number"
                            name="calories"
                            placeholder="קלוריות"
                            value={caloricGoal.calories}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="form-group">
                        <label>חלבונים (g)</label>
                        <input
                            type="number"
                            name="proteins"
                            placeholder="חלבונים"
                            value={caloricGoal.proteins}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="form-group">
                        <label>פחמימות (g)</label>
                        <input
                            type="number"
                            name="carbs"
                            placeholder="פחמימות"
                            value={caloricGoal.carbs}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="form-group">
                        <label>שומנים (g)</label>
                        <input
                            type="number"
                            name="fats"
                            placeholder="שומנים"
                            value={caloricGoal.fats}
                            onChange={handleInputChange}
                        />
                    </div>
                    <button type="submit" className="save-button">שמירה</button>
                </form>
            </Modal>
        </div>
    );
};

export default CaloricGoal;
